import CustomSelect from '@/views/custom_select';
import ComposableForm from '@/views/composable_form';

let countryCodeCustomSelect = null;
let composableForm = null;

pageUnload('info_pages_show', () => {
  if (countryCodeCustomSelect) {
    countryCodeCustomSelect.destroy();
    countryCodeCustomSelect = null;
  }

  if (composableForm) {
    composableForm.destroy();
    composableForm = null;
  }
});

pageLoad('info_pages_show', () => {
  const formNode = document.querySelector('form#new_crm_lead');
  if (!formNode) { return; }

  countryCodeCustomSelect = new CustomSelect(
    formNode.querySelector('.b-input-v4.country_code')
  );

  composableForm = new ComposableForm(formNode, {
    fields: [
      formNode.querySelector('#crm_lead_client'),
      formNode.querySelector('#crm_lead_phone')
    ]
  });

  const privacyConsentNode = formNode.querySelector('.b-input-v4.privacy-consent');
  if (privacyConsentNode) {
    $(formNode)
      .on('submit', e => {
        const consentCheckboxNode = privacyConsentNode.querySelector('input');
        if (!consentCheckboxNode.checked) {
          privacyConsentNode.classList.add('field_with_errors');

          e.preventDefault();
          e.stopImmediatePropagation();
        }
      })
      .on('ajax:success', async e => {
        formNode.querySelectorAll('.b-input-v4 input').forEach(node => node.value = '');

        const { thanksModal } = await import(
          /* webpackChunkName: "modal" */
          '@/views/modal/thanks_modal'
        );
        thanksModal();

        // TODO: @blackchestnut, тут что-то должно быть?
        // track({ event: 'callback_form_sent', form_location: 'last_screen' });
      });

    $(privacyConsentNode).on('change', () => {
      privacyConsentNode.classList.remove('field_with_errors');
    });
  }
});
